(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('message-history', {
                parent: 'entity',
                url: '/message-history',
                data: {
                    authorities: [],
                    pageTitle: 'MessageHistories'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message-history/list/message-history.html',
                        controller: 'MessageHistoryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id,
                            employee: null,
                            phoneNumber: null,
                            date: null
                        };
                    }]
                }
            })
    }
})();
